import { number, object, string } from 'yup'

export const wallFormV2Schema = object({
  guid: string(),
  start: object({
    x: number(),
    y: number(),
    z: number(),
  }),
  end: object({
    x: number(),
    y: number(),
    z: number(),
  }),
  placement: string(),
})
